import React, {useEffect, useState} from 'react';
import ProductImageSmall from "../product-upload/product-image-small";
import _ from "lodash";
import {getAllPODProducts, searchProducts} from "../../services/product-data-service";
import {PRODUCT_DETAIL_KEY, SAVE_POD_TIME_DELAY, SEARCH_PRODUCTS_TIME_DELAY} from "../../constants/pod.constant";
import {TrashIcon} from "@heroicons/react/24/solid";

const ParentProductFilters = ({
                                  podDetail,
                                  filterCriteria,
                                  setFilterCriteria,
                                  searchProductsList,
                                  enableEdit,
                                  setEnableEdit
                              }) => {
    const [selectedProductType, setSelectedProductType] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    let [changesCount, setChangesCount] = useState(0);

    const handleFilterChanges = (event) => {
        const {name, value} = event.target;

        // console.log(name, ' - ', value);

        if (name === PRODUCT_DETAIL_KEY.PRODUCT_TYPE) {
            const productTypesMap = _.keyBy(podDetail?.productTypesList, 'name');
            const tempSelectedProductType = productTypesMap[value];

            setSelectedProductType(tempSelectedProductType);
            clearSelectedCategory();
        } else if (name === PRODUCT_DETAIL_KEY.CATEGORY) {
            const categoriesMap = _.keyBy(selectedProductType?.categories, 'name');
            const tempSelectedCategory = categoriesMap[value];

            setSelectedCategory(tempSelectedCategory);
        }

        prepareFilterCriteria(name, value);
    }

    const clearSelectedProductType = () => {
        setSelectedProductType(null);
        clearSelectedCategory();
    }

    const clearSelectedCategory = () => {
        setSelectedCategory(null);
    }

    const prepareFilterCriteria = (name, value) => {
        const existingFilterCriteria = {...filterCriteria};
        existingFilterCriteria[name] = value;
        setFilterCriteria(existingFilterCriteria);
    }

    const handleClearFilters = () => {
        setSelectedProductType(null);
        setSelectedCategory(null);

        setFilterCriteria({
            productType: '',
            category: '',
        });
    }

    useEffect(() => {
        incrementChangesCount();
    }, [filterCriteria]);

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {

                if (changesCount > 0) {
                    resetChangesCount();
                    searchProductsList();
                }

            }, SEARCH_PRODUCTS_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    }, [changesCount]);

    const incrementChangesCount = () => {
        setChangesCount(++changesCount);
    }

    const resetChangesCount = () => {
        setChangesCount(0);
    }

    return (
        <>

            <div className="flex justify-between">
                <div className="field-group-container">

                    {/*<div className="field-container">
                        <div className="field-label">
                            Product Name
                        </div>
                        <input
                            type="text"
                            className="input-field-max"
                            id="name"
                            name="name"
                            value={filterCriteria?.name}
                            onChange={handleFilterChanges}>
                        </input>
                    </div>*/}

                    <div className="field-container">
                        <div className="field-label">
                            Product Type <span
                            className="pl-1 text-gray-400">({podDetail?.productTypesList?.length})</span>
                        </div>
                        <select
                            className="input-field"
                            id="productType"
                            name="productType"
                            value={filterCriteria?.productType}
                            onChange={handleFilterChanges}>
                            <option value="">All Product Types</option>
                            {podDetail?.productTypesList?.map((option, index) => (
                                <option key={index}
                                        value={option?.name}>
                                    {option?.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="field-container">
                        <div className="field-label">
                            Category
                            {selectedProductType &&
                                <span
                                    className="pl-1 text-gray-400">({selectedProductType?.categories?.length})</span>
                            }
                        </div>
                        <select
                            className="input-field"
                            id="category"
                            name="category"
                            value={filterCriteria?.category}
                            onChange={handleFilterChanges}>
                            <option value="">All Categories</option>
                            {selectedProductType?.categories?.map((option, index) => (
                                <option key={index}
                                        value={option?.name}>{option?.name}</option>
                            ))}
                        </select>
                    </div>

                    <button
                        onClick={() => handleClearFilters()}
                        className="button-small-link mt-7">
                        Clear Filters
                    </button>

                </div>

                <div className="">
                    <button
                        onClick={() => setEnableEdit(!enableEdit)}
                        className="button-small mt-7 ml-4 w-48">
                        {!enableEdit && <span>Edit Fields</span>}
                        {enableEdit && <span>Ready Only Fields</span>}
                    </button>
                </div>
            </div>

        </>
    )
}

export default ParentProductFilters
